function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgSpeaker = function SvgSpeaker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("path", {
    style: {
      fill: "#DA5B65"
    },
    d: "M174.787,276.95l-42.628,67.302l42.628,54.591h20.783c17.214,0,31.169-13.955,31.169-31.169V276.95 H174.787z"
  }), React.createElement("path", {
    style: {
      fill: "#C0344A"
    },
    d: "M147.117,320.634l14.648,15.007h13.02c18.556,0,35.842,0.334,51.952,0.943v-59.632h-51.952 L147.117,320.634z"
  }), React.createElement("path", {
    style: {
      fill: "#EFEDEE"
    },
    d: "M124.242,276.95L89.53,304.735c0,0,23.564,38.02,25.884,150.199 c0.205,9.911,8.325,17.832,18.239,17.832h22.887c10.077,0,18.247-8.169,18.247-18.247V304.735L124.242,276.95z"
  }), React.createElement("path", {
    style: {
      fill: "#FF9AC8"
    },
    d: "M464.664,62.9c0,0-31.784,62.775-289.878,62.775l-87.393,89.53l87.393,89.53 c258.093,0,289.878,62.775,289.878,62.775l23.667-152.305L464.664,62.9z"
  }), React.createElement("path", {
    style: {
      fill: "#E86FA8"
    },
    d: "M464.664,326.303c0,0-31.784-62.775-289.878-62.775l-67.281-68.926l-20.112,20.604l87.393,89.53 c258.093,0,289.878,62.775,289.878,62.775l23.667-152.305l-3.202-20.604L464.664,326.303z"
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#3A484A"
    },
    d: "M240.919,224.791c-4.267,0-7.726-3.459-7.726-7.726v-14.245c0-4.267,3.459-7.726,7.726-7.726 c4.267,0,7.726,3.459,7.726,7.726v14.245C248.646,221.332,245.187,224.791,240.919,224.791z"
  }), React.createElement("path", {
    style: {
      fill: "#3A484A"
    },
    d: "M398.339,224.791c-4.267,0-7.726-3.459-7.726-7.726v-14.245c0-4.267,3.459-7.726,7.726-7.726 s7.726,3.459,7.726,7.726v14.245C406.065,221.332,402.606,224.791,398.339,224.791z"
  }), React.createElement("path", {
    style: {
      fill: "#3A484A"
    },
    d: "M319.629,235.319c-11.532,0-22.352-4.812-29.686-13.202c-2.808-3.213-2.481-8.093,0.732-10.902 c3.213-2.809,8.094-2.481,10.902,0.731c4.4,5.032,10.979,7.919,18.052,7.919c7.073,0,13.652-2.887,18.051-7.919 c2.808-3.213,7.69-3.541,10.902-0.732c3.213,2.808,3.542,7.689,0.732,10.902C341.982,230.507,331.162,235.319,319.629,235.319z"
  })), React.createElement("path", {
    style: {
      fill: "#49C3E0"
    },
    d: "M488.332,39.233c-13.072,0-23.668,10.596-23.668,23.668v304.61c0,13.072,10.596,23.668,23.668,23.668 S512,380.582,512,367.51V62.9C512,49.829,501.404,39.233,488.332,39.233z"
  }), React.createElement("path", {
    style: {
      fill: "#00A5C6"
    },
    d: "M488.332,349.972c-13.072,0-23.668-10.596-23.668-23.668v41.207 c0,13.071,10.596,23.668,23.668,23.668S512,380.582,512,367.51v-41.207C512,339.375,501.404,349.972,488.332,349.972z"
  }), React.createElement("path", {
    style: {
      fill: "#D4D2D3"
    },
    d: "M89.53,304.735c0,0,5.535,8.931,11.504,30.905h73.753v-30.905l-50.545-27.785L89.53,304.735z"
  }), React.createElement("path", {
    style: {
      fill: "#49C3E0"
    },
    d: "M89.53,125.675C40.084,125.675,0,165.76,0,215.205l0,0c0,49.446,40.084,89.53,89.53,89.53h85.256 v-179.06H89.53z"
  }), React.createElement("path", {
    style: {
      fill: "#00A5C6"
    },
    d: "M2.387,194.602C0.828,201.218,0,208.115,0,215.205l0,0c0,49.446,40.084,89.53,89.53,89.53h85.257 v-41.207H89.53C47.175,263.528,11.694,234.115,2.387,194.602z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSpeaker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/speaker.4e49cbb0.svg";
export { ForwardRef as ReactComponent };